(function () {
  if (window.__everloveCustomizeV1) return;
  window.__everloveCustomizeV1 = true;

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function findVisibleAddForm() {
    const forms = qsa('form[action*="/cart/add"]');
    return forms.find(f => f.offsetParent !== null) || forms[0] || null;
  }

  function init() {
    const wrap = qs('[data-everlove-customize]');
    if (!wrap) return;

    // IMPORTANT: put the customizer INSIDE the real add-to-cart form so Shopify receives properties
    const form = wrap.closest('form[action*="/cart/add"]') || findVisibleAddForm();
    if (!form) return;

    if (!form.contains(wrap)) {
      form.insertBefore(wrap, form.firstChild);
    }

    // Product-page image preview (free)
    const imgInput = qs('#everlove-image', wrap);
    const preview = qs('#everlove-preview', wrap);
    const previewImg = qs('#everlove-preview-img', wrap);
    const previewName = qs('#everlove-preview-name', wrap);

    if (imgInput && preview && previewImg && previewName) {
      imgInput.addEventListener('change', () => {
        const f = imgInput.files && imgInput.files[0];
        if (!f) { preview.style.display = 'none'; return; }
        previewName.textContent = f.name;
        previewImg.src = URL.createObjectURL(f);
        preview.style.display = 'flex';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
